<template>
	<div class="grid-content">
		<div class="grid-content-title">
			<div class="name">{{title}}</div>
			<div class="right">
				<el-button size="mini" @click="refreshOrder">
					<i class="el-icon-refresh"></i>
					<span>刷新</span>
				</el-button>
			</div>
		</div>
		<div class="grid-content-search">
			<div class="line">
				<el-row :gutter="20">
					<el-col :span="10">
						<div class="box">
							<div class="label">订单查询：</div>
							<div class="input">
								<el-input v-model="query.keyword" placeholder="请输入关键字" class="input-with-select"
									size="small" clearable>
									<el-select v-model="query.keytype" slot="prepend" placeholder="请选择类型">
										<el-option label="按订单编号" value="no"></el-option>
										<el-option label="按用户ID" value="user"></el-option>
										<el-option label="司机姓名" value="name"></el-option>
									</el-select>
								</el-input>
							</div>
						</div>
					</el-col>
					<el-col :span="7">
						<div class="box">
							<div class="label">订单类型：</div>
							<div class="input">
								<el-select v-model="query.type" placeholder="请选择" size="small" style="width: 100%;">
									<el-option label="公众号单" value="g"></el-option>
									<el-option label="小程序单" value="d"></el-option>
									<el-option label="扫码单" value="m"></el-option>
									<el-option label="自建单" value="z"></el-option>
									<el-option label="电话单" value="s"></el-option>
									<el-option label="优惠单" value="y"></el-option>
									<el-option label="门店单" value="h"></el-option>
								</el-select>
							</div>
						</div>
					</el-col>
					<el-col :span="7">
						<div class="box">
							<div class="label">支付方式：</div>
							<div class="input">
								<el-select v-model="query.pay" placeholder="请选择" size="small" style="width: 100%;" disabled>
									<el-option label="微信支付" value="shanghai"></el-option>
									<el-option label="小程序支付" value="shanghai"></el-option>
									<el-option label="H5支付" value="shanghai"></el-option>
									<el-option label="线下支付" value="beijing"></el-option>
								</el-select>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="line">
				<el-row :gutter="20">
					<el-col :span="11">
						<div class="box">
							<div class="label">下单时间：</div>
							<div class="input">
								<el-date-picker v-model="query.date" type="daterange" range-separator="至"
									start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" size="small" style="width: 100%;">
								</el-date-picker>
							</div>
						</div>
					</el-col>
					<el-col :span="13">
						<el-button type="primary" icon="el-icon-search" size="small" style="width: 6rem;"
							@click="searchOrder">搜索</el-button>
						<el-button size="small" @click="resetSearchOrder">重置</el-button>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="grid-content-list order">
			<div class="common-table">
				<table class="header">
					<colgroup>
						<col width="4%">
						<col>
						<col width="30%">
						<col width="11%">
						<col width="11%">
						<col width="12%">
						<col width="15%">
					</colgroup>
					<thead>
						<tr>
							<th>
								<el-checkbox></el-checkbox>
							</th>
							<th>用户</th>
							<th>地址信息</th>
							<th>服务费</th>
							<th>司机</th>
							<th>状态</th>
							<th>操作</th>
						</tr>
					</thead>
				</table>
				<table class="body" v-loading="(loading && total>0)?true:false">
					<colgroup>
						<col width="4%">
						<col>
						<col width="30%">
						<col width="11%">
						<col width="11%">
						<col width="12%">
						<col width="15%">
					</colgroup>
					<thead>
						<template v-for="(item,index) in list">
							<tr class="separation-row">
								<td colspan="7"></td>
							</tr>
							<tr class="header-row">
								<td colspan="7">
									<div class="item">
										<div class="left">
											<div>
												<span>订单号：</span>
												<span style="color: #00c7c7;">[{{item.order_type}}]</span>
												<span>{{item.order_no}}</span>
												<span style="margin-left: 0.3125rem;cursor: pointer;"
													:class="'copy-'+item.order_id" class="el-icon-document-copy"
													:data-clipboard-text="item.order_no"
													@click="copyOrder(item.order_id)"></span>
											</div>
											<div>
												<span>区域：</span>
												<span style="color: #409EFF;">{{item.order_city}}</span>
											</div>
											<div>
												<span>创建时间：{{item.create_time}}</span>
												<el-popover placement="bottom" trigger="hover">
													<div class="popover-info">
														<div class="title">订单时间</div>
														<div class="item">
															<label>到达位置</label>
															<span>{{item.step1}}</span>
														</div>
														<div class="item">
															<label>开始代驾</label>
															<span>{{item.step2}}</span>
														</div>
														<div class="item">
															<label>完成代驾</label>
															<span>{{item.step3}}</span>
														</div>
														<div class="item">
															<label>支付时间</label>
															<span>{{item.pay_info.pay_time}}</span>
														</div>
													</div>
													<span style="color: #FF8E43;margin-left: 0.625rem;cursor: pointer;"
														slot="reference">更多</span>
												</el-popover>
											</div>
										</div>
										<div class="right">
											<el-popconfirm confirm-button-text='确定' cancel-button-text='不用了'
												icon="el-icon-info" icon-color="red" title="删除后不可恢复，确定删除吗？">
												<div class="del el-icon-delete" slot="reference"></div>
											</el-popconfirm>
										</div>
									</div>
								</td>
							</tr>
							<tr class="content-row">
								<td>
									<div style="display: flex;align-items: center;justify-content: center;">
										<el-checkbox></el-checkbox>
									</div>
								</td>
								<td>
									<div class="user">
										<img v-if="item.user.head" :src="item.user.head" class="avatar">
										<img v-else src="../../assets/custom_head.png" class="avatar">
										<div class="info">
											<div v-if="item.user.name" class="name link" @click="userOrder(item.user.uid)">
												{{item.user.name}}
											</div>
											<div v-else class="name">null</div>
											<div v-if="item.user.uid" class="id">ID:{{item.user.uid}}</div>
											<div v-else class="id">ID:-</div>
										</div>
										<div v-if="item.discount" class="discount">优惠</div>
										<div class="grade">
											<div class="bg"></div>
											<div class="text">普通</div>
										</div>
									</div>
								</td>
								<td>
									<div class="address">
										<div class="start">
											<div class="icon">起</div>
											<div class="text">{{item.start_title}}</div>
										</div>
										<div class="end">
											<div class="icon">终</div>
											<div v-if="item.status==0" class="text">-</div>
											<template v-else>
												<div v-if="item.status==1 || item.status==2" class="text"><i
														class="el-icon-loading"></i></div>
												<div v-else class="text">{{item.end_title}}</div>
											</template>
										</div>
									</div>
								</td>
								<td>
									<div class="cost">
										<div class="amount" v-if="item.status==0">-</div>
										<template v-else>
											<div class="amount" v-if="item.status==1 || item.status==2">
												<i class="el-icon-loading"></i>
											</div>
											<template v-else>
												<div class="amount">
													<span>{{item.amount}}</span>
													<el-popover v-if="item.status==3" placement="bottom" trigger="click"
														@hide="editAmountOrderHide" :ref="'popoverEditAmonut-'+index">
														<div class="edit-amount">
															<div
																style="color: black;font-size: 0.875rem;font-weight: bold;margin-bottom: 0.625rem;">
																修改服务费</div>
															<el-form :model="edit" :inline="true"
																class="edit-form-inline">
																<el-form-item style="margin-bottom: 0.625rem;">
																	<el-input v-model.number="edit.amount" clearable
																		oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
																		size="small" placeholder="请输入金额，不得为负数"
																		:disabled="edit.loading">
																		<i slot="prefix"
																			class="el-input__icon el-icon-edit"></i>
																	</el-input>
																</el-form-item>
																<el-form-item style="margin-bottom: 0.625rem;">
																	<el-button v-if="edit.loading" size="small"
																		type="primary" :loading="edit.loading">
																	</el-button>
																	<el-button v-else size="small" type="primary"
																		@click="editAmountOrder">修改</el-button>
																</el-form-item>
															</el-form>
														</div>
														<i class="el-icon-edit" slot="reference"
															@click="edit.index = index"></i>
													</el-popover>
												</div>
												<div class="mileage">{{item.mileage}}</div>
											</template>
										</template>
									</div>
								</td>
								<td>
									<div v-if="item.driver.name" class="driver">
										<div class="name">
											<span>{{item.driver.name}}</span>
											<el-tooltip v-if="item.look" class="item" effect="dark" content="已接收新订单通知"
												placement="top">
												<i class="el-icon-s-flag look"></i>
											</el-tooltip>
											<i v-else class="el-icon-s-flag"></i>
										</div>
										<div class="phone">{{item.driver.phone}}</div>
									</div>
									<div v-else style="text-align: center;">
										<span>-</span>
									</div>
								</td>
								<td>
									<div class="status">
										<div v-if="item.status==0" class="box">
											<div style="color: #999;">
												<i class="el-icon-error" style="margin-right: 0.125rem;"></i>
												<span>订单取消</span>
											</div>
											<el-tooltip class="item" effect="dark" :content="item.cancel_cause"
												placement="top">
												<div class="link" style="text-align: center;">查看</div>
											</el-tooltip>
										</div>
										<div v-if="item.status==1" class="box">
											<div style="color: #e6a23c;">
												<i class="el-icon-location" style="margin-right: 0.125rem;"></i>
												<span>已到达</span>
											</div>
											<div>
												<el-button size="mini" style="transform: scale(.8);"
													@click="cancelDispatch(item.order_id, item.order_no)">取消
												</el-button>
											</div>
										</div>
										<div v-if="item.status==2" style="color: #409eff;">
											<i class="el-icon-loading" style="margin-right: 0.125rem;"></i>
											<span>服务中</span>
										</div>
										<div v-if="item.status==3" class="box">
											<div style="color: #f56c6c;">
												<i class="el-icon-warning" style="margin-right: 0.125rem;"></i>
												<span>尚未支付</span>
											</div>
											<div>
												<el-dropdown trigger="click"
													@command="settleOrder($event, item.order_id)">
													<el-button plain size="mini" class="js">
														<span>结算</span>
														<i class="el-icon-arrow-down"></i>
													</el-button>
													<el-dropdown-menu slot="dropdown">
														<el-dropdown-item command="1">线下结算</el-dropdown-item>
														<el-dropdown-item command="2">微信支付</el-dropdown-item>
													</el-dropdown-menu>
												</el-dropdown>
											</div>
										</div>
										<div v-if="item.status==4" class="box">
											<div style="color: #07c160;">
												<i class="el-icon-success" style="margin-right: 0.125rem;"></i>
												<span>支付完成</span>
											</div>
											<el-popover placement="bottom" trigger="hover">
												<div class="popover-info">
													<div class="title">支付详情</div>
													<div class="item">
														<label>支付类型</label>
														<span v-if="item.pay_info.type=='WEAPP_JSAPI'">小程序支付</span>
														<span v-else-if="item.pay_info.type=='DRIVER_HAND'">线下支付</span>
														<span v-else-if="item.pay_info.type=='JSAPI'">H5支付</span>
														<span v-else-if="item.pay_info.type=='NATIVE'">扫码支付</span>
														<span v-else>-</span>
													</div>
													<div class="item">
														<label>实付金额</label>
														<span>{{item.pay_info.amount}}</span>
													</div>
													<div class="item">
														<label>支付单号</label>
														<span>{{item.pay_info.pay_no}}</span>
													</div>
													<div class="item">
														<label>支付时间</label>
														<span>{{item.pay_info.pay_time}}</span>
													</div>
												</div>
												<div class="link" style="text-align: center;" slot="reference">查看
												</div>
											</el-popover>
										</div>
									</div>
								</td>
								<td>
									<div class="operate">
										<el-button plain size="mini" :disabled="(item.status<1)?true:false"
											@click="mapOrder(item.order_id)">地图
										</el-button>
										<el-button plain size="mini" :disabled="(item.status<3)?true:false"
											@click="infoOrder(index)">详情
										</el-button>
									</div>
								</td>
							</tr>
						</template>
					</thead>
				</table>
			</div>
			<div v-if="loading && total<=0" style="min-height: 20rem;" v-loading="loading"></div>
			<div v-if="total>0" class="page">
				<el-pagination background layout="total, prev, pager, next" :current-page.sync="page" :total="total"
					@current-change="pageOrder">
				</el-pagination>
			</div>
			<el-empty v-if="!loading && total<=0" description="暂无订单数据" :image-size="100"></el-empty>
		</div>
		<el-drawer title="订单地图" size="60%" :visible.sync="map.show">
			<div :style="{position:'relative',width:'100%',height:'100%',padding:'0 20px 20px','box-sizing': 'border-box'}"
				v-loading="map.loading">
				<el-amap :amap-manager="map.amapManager" vid="amap" :center="map.center" :zoom="map.zoom"
					:zooms="[10,18]" :events="map.events">
				</el-amap>
			</div>
		</el-drawer>
		<el-drawer title="订单详情" size="30%" :visible.sync="info.show">
			<div class="order_project">
				<div :style="{flex:'1'}">
					<el-divider>服务费</el-divider>
					<div class="amount">{{info.data.amount}}</div>
					<el-divider>计费详情</el-divider>
					<el-form label-position="left" inline>
						<el-form-item v-for="(item,index) in info.data.project" :label="item.a" :key="index">
							<span :style="{'color':item.b_c}">{{item.b}}</span>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import {
		AMapManager,
		lazyAMapApiLoaderInstance
	} from "vue-amap";
	import Clipboard from 'clipboard';
	const amapManager = new AMapManager();
	export default {
		data() {
			const self = this;
			return {
				title: "全部订单",
				loading: true,
				status: 0,
				query: {},
				page: 1,
				total: 0,
				list: [],
				edit: {
					loading: false,
					index: 0,
					amount: ''
				},
				info: {
					show: false,
					data: {}
				},
				map: {
					show: false,
					loading: true,
					oid: 0,
					amapManager,
					center: [116.397428, 39.909231],
					zoom: 12,
					events: {
						init() {
							lazyAMapApiLoaderInstance.load().then(() => {
								self.initMap();
							});
						}
					}
				}
			};
		},
		created() {
			if (this.$route.params.query != undefined) {
				this.query = this.$route.params.query
			}
			this.resetTitle();
		},
		methods: {
			initMap() {
				const that = this;
				const info = localStorage.getItem("_JIAZHI_info");
				if (Boolean(info)) {
					const adminInfo = JSON.parse(info);
					that.map.center = [adminInfo.location[1], adminInfo.location[0]];
					that.mapOrder(that.map.oid, false);
					console.log("初始化地图");
				}
			},
			resetTitle() {
				const that = this;
				switch (that.$route.name) {
					case "order_list_arrive":
						that.title = "已到达";
						that.status = 1;
						break;
					case "order_list_service":
						that.title = "服务中";
						that.status = 2;
						break;
					case "order_list_pay":
						that.title = "待支付";
						that.status = 3;
						break;
					case "order_list_complete":
						that.title = "已完成";
						that.status = 4;
						break;
					case "order_list_cancel":
						that.title = "已取消";
						that.status = 5;
						break;
					default:
						that.title = "全部订单";
						that.status = 0;
				}
				that.pageOrder(1);
			},
			searchOrder() {
				const that = this;
				const query = Object.keys(that.query);
				if (query.length <= 0) {
					that.$message.error("错误：至少需要一个搜索项");
				} else {
					if (that.query.keyword && that.query.keytype == undefined) {
						that.$message.error("错误：请选择关键字类型");
						return;
					}
					if (that.query.keyword == undefined && that.query.keytype) {
						that.$message.error("错误：请输入搜索关键字");
						return;
					}
					that.pageOrder(1);
				}
			},
			resetSearchOrder() {
				this.query = {};
				this.pageOrder(1);
			},
			editAmountOrder() {

			},
			editAmountOrderHide() {

			},
			copyOrder(oid) {
				const that = this;
				var clipboard = new Clipboard('.copy-' + oid);
				clipboard.on('success', e => {
					that.$message.success("复制成功");
					clipboard.destroy();
				});
				clipboard.on('error', e => {
					// 不支持复制
					that.$message.error("复制失败，请手动操作复制");
					// 释放内存  
					clipboard.destroy();
				});
			},
			mapOrder(oid, show = true) {
				const that = this;
				that.map.oid = oid;
				if (show) {
					that.map.show = true;
					that.map.loading = true;
				}
				const map = that.map.amapManager.getMap();
				if (map) {
					map.clearMap();
					console.log("请求地图路径");
					that.$post('orderMap', {
						oid: oid
					}).then(res => {
						console.log(res);
						var content, offset;
						that.map.loading = false;
						//装载路线
						if (res.data.path.length > 0) {
							var polyline = new AMap.Polyline({
								path: res.data.path, // 设置线覆盖物路径
								showDir: true,
								strokeColor: '#921dfe', // 线颜色
								strokeWeight: 5 // 线宽
							});
							map.add([polyline]);
						}
						//遍历自定义marker数据
						for (var i = 0; i < res.data.marker.length; i++) {
							if (res.data.marker[i].type == "start") {
								content = '<div class="map-start">起</div>';
								offset = new AMap.Pixel(-16, -34);
							} else if (res.data.marker[i].type == "end") {
								content = '<div class="map-end">终</div>';
								offset = new AMap.Pixel(-16, -34);
							}
							new AMap.Marker({
								offset: offset,
								position: new AMap.LngLat(res.data.marker[i].longitude, res
									.data.marker[i]
									.latitude),
								content: content,
								map: map
							});
						}
						if (res.data.marker.length > 1) {
							map.setFitView();
						} else {
							map.setZoom(14);
						}
					}).catch(e => {
						that.map.show = false;
						that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
							"未知错误，请重试", '提示', {
								confirmButtonText: '确定'
							});
					});
				}
			},
			settleOrder(e, oid) {
				const that = this;
				console.log(e);
				console.log(oid);

				if (e == 2) {
					that.$message.error("暂未开通后台微信支付");
				}
			},
			infoOrder(index) {
				this.info.show = true;
				this.info.data = this.list[index];
			},
			refreshOrder() {
				this.pageOrder(1);
			},
			pageOrder(e) {
				this.page = e;
				this.postOrder(this.query);
			},
			postOrder(query = {}) {
				const that = this;
				that.loading = true;
				that.$post('order', {
					query: that.query,
					status: that.status,
					page: that.page
				}).then(res => {
					setTimeout(function() {
						that.loading = false;
						that.total = res.data.total;
						res.data.list.map((item) => {
							item.checked = false;
							return item;
						});
						that.list = res.data.list;
					}, 500);
				}).catch(e => {
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message : "未知错误，请重试",
						'提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		},
		watch: {
			$route: {
				handler: 'resetTitle'
			}
		}
	}
</script>

<style scoped>
	.order .header-row {
		font-size: 0.8125rem;
		background: #F7F7F7;
	}

	.order .header-row .item {
		display: flex;
		padding: 0.3rem 0.625rem;
	}

	.order .header-row .left {
		flex: 1;
		display: flex;
	}

	.order .header-row .left div:nth-child(1) {
		width: 16.5rem;
	}

	.order .header-row .left div:nth-child(2) {
		width: 7.5rem;
	}

	.order .header-row .right .del {
		cursor: pointer;
	}

	.order .user {
		display: flex;
		align-items: center;
		padding: 10px;
		position: relative;
	}

	.order .user .avatar {
		width: 2.5rem;
		height: 2.5rem;
		border-radius: 0.375rem;
	}

	.order .user .info {
		margin-left: 0.3125rem;
	}

	.order .user .info .name {
		font-size: 0.875rem;
		font-weight: bold;
		color: #576b95
	}

	.order .user .info .id {
		color: #666;
		margin-top: 0.3rem;
		font-size: 0.75rem;
	}

	.order .user .discount {
		position: absolute;
		top: -0.5rem;
		right: -0.4rem;
		color: white;
		font-size: .75rem;
		width: 2.5rem;
		height: 1.9375rem;
		line-height: 1.6rem;
		text-align: center;
		background-image: url(../../assets/corner_marker.png);
		background-size: 100% 100%;
		transform: scale(.7);
	}

	.order .user .grade {
		position: absolute;
		top: -0.125rem;
		left: -0.125rem;
	}

	.order .user .grade .bg {
		border-left: 2.5rem solid #7b7e93;
		border-bottom: 2.5rem solid transparent;
	}

	.order .user .grade .text {
		position: absolute;
		top: 0.3125rem;
		left: 0;
		color: white;
		font-weight: bold;
		text-align: center;
		font-size: 0.75rem;
		transform: scale(.8);
		transform: rotate(-45deg);
	}

	/* 	.order .user .info .lv {
		line-height: 1rem;
	}

	.order .user .info .lv img {
		width: 2rem;
	} */

	/* 	.order .user .discount {
		position: absolute;
		top: -0.5rem;
		left: -0.625rem;
		color: white;
		font-size: 0.75rem;
		width: 2.5rem;
		height: 1.9375rem;
		line-height: 1.6rem;
		text-align: center;
		background-image: url(assets/corner_marker.png);
		background-size: 100% 100%;
		transform: scale(.7);
	} */

	.order .address {
		padding: 0 0.9375rem;
		box-sizing: border-box;
	}

	.order .address .start,
	.order .address .end {
		display: flex;
		align-items: center;
		margin: 0.125rem 0;
	}

	.order .address .start .icon,
	.order .address .end .icon {
		font-size: 0.75rem;
		color: white;
		width: 18px;
		line-height: 18px;
		text-align: center;
		background-color: #6be1a3;
		margin-right: 5px;
		border-radius: 2px;
	}

	.order .address .end .icon {
		background-color: #ef6d6d;
	}

	.order .address .start .text,
	.order .address .end .text {
		flex: 1;
		color: #606266;
		font-size: .875rem;
		font-weight: bold;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.order .cost .amount {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.order .cost .amount span {
		font-family: WechatSans;
		font-size: 1.1rem;
	}

	.order .cost .amount i {
		cursor: pointer;
		font-weight: bold;
		font-size: 0.85rem;
		margin-left: 0.3rem;
	}

	.order .cost .mileage {
		font-size: 0.75rem;
		color: #666;
		text-align: center;
	}

	.order .driver {
		font-size: 0.75rem;
		text-align: center;
	}

	.order .driver .name {
		color: #333;
		font-size: 0.8125rem;
		font-weight: bold;
	}

	.order .driver .name i {
		color: #999999;
		margin-left: 0.3125rem;
	}

	.order .driver .name i.look {
		color: #67c23a;
	}

	.order .driver .phone {
		color: #666;
	}

	.order .status {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.75rem;
	}

	.order .status .js {
		transform: scale(.8);
	}

	.order .operate {
		display: flex;
		justify-content: center;
	}







	.popover-info {
		min-width: 15.625rem;
	}

	.popover-info .title {
		font-size: 0.875rem;
		font-weight: bold;
		margin-bottom: 0.625rem;
	}

	.popover-info .item {
		font-size: 0.75rem;
		line-height: 1.25rem;
	}

	.popover-info .item label {
		display: inline-block;
		width: 25%;
		color: #99a9bf;
	}

	.order_project {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		padding: 0 2.5rem 2.5rem;
		box-sizing: border-box;
	}

	.order_project .amount {
		font-family: WechatSans;
		font-size: 3rem;
		text-align: center;
	}

	.order_project .el-divider__text {
		color: #999;
		font-size: .75rem
	}

	.order_project .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 100%
	}

	.order_project .el-form-item>>>label {
		width: 60%;
		color: #99a9bf
	}

	.order_project .el-form-item>>>.el-form-item__content {
		width: 40%;
		text-align: right
	}

	>>>.map-start,
	>>>.map-end {
		width: 1.875rem;
		line-height: 1.875rem;
		color: #fff;
		font-size: 0.75rem;
		text-align: center;
		border-radius: 3.125rem;
		background-color: #00aeff;
		position: relative;
	}

	>>>.map-end {
		background-color: red;
	}

	>>>.map-start::before,
	>>>.map-end::before {
		content: '';
		width: 0;
		height: 0;
		border: 5px solid;
		position: absolute;
		bottom: -9px;
		left: 50%;
		margin-left: -5px;
		border-color: #00aeff transparent transparent;
	}

	>>>.map-end::before {
		border-color: red transparent transparent;
	}
</style>
